import { defineMessages } from "react-intl";

import { validator } from "lib/build/forms/ktx/transplantation-screening/lab-procedures/thrombocyte";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	thrombocyte: {
		id: "ktx.thrombocyte.title",
		defaultMessage: "Trombocyta"
	},
	value: {
		id: "ktx.thrombocyte.field.value",
		defaultMessage: "Érték"
	}
});

const fields: { [key: string]: FieldData } = {
	value: {
		type: "field",
		path: ["value"],
		label: messages.value,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.value }] }]
};

export const node: LeafNode = {
	id: "ktx_thrombocyte",
	value: {
		schemaId: "thrombocyte",
		title: messages.thrombocyte,
		validator,
		fieldset,
		applyCurrentDate: false
	}
};
